import clsx from 'clsx';

import type { IconProps } from '.';

/**
 * Search Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const SearchIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={clsx(className, 'nav_loop_icon')}
  >
    <path
      d="M11.5 5.00001C9.77609 5.00001 8.12279 5.68483 6.90381 6.90382C5.68482 8.12281 5 9.77611 5 11.5C5 13.2239 5.68482 14.8772 6.90381 16.0962C8.12279 17.3152 9.77609 18 11.5 18C13.2239 18 14.8772 17.3152 16.0962 16.0962C17.3152 14.8772 18 13.2239 18 11.5C18 9.77611 17.3152 8.12281 16.0962 6.90382C14.8772 5.68483 13.2239 5.00001 11.5 5.00001ZM4 11.5C4 10.2878 4.29383 9.09363 4.85634 8.01981C5.41884 6.94599 6.23325 6.02453 7.22981 5.33433C8.22636 4.64414 9.37537 4.2058 10.5784 4.05684C11.7814 3.90788 13.0027 4.05275 14.1375 4.47905C15.2723 4.90534 16.2868 5.60035 17.0942 6.50455C17.9017 7.40875 18.4779 8.49518 18.7735 9.6708C19.0692 10.8464 19.0755 12.0762 18.7918 13.2548C18.5082 14.4333 17.9431 15.5256 17.145 16.438L21.354 20.646L20.646 21.354L16.438 17.145C15.3536 18.0936 14.0189 18.7098 12.5935 18.9199C11.1681 19.1299 9.71239 18.925 8.40041 18.3295C7.08843 17.7341 5.97573 16.7734 5.19536 15.5622C4.415 14.3511 4 12.9408 4 11.5Z"
      fill="white"
    />
  </svg>
);

export default SearchIcon;
